(function ($) {
    $.Redactor.prototype.table = function () {
        return {
            langs: {
                en: {
                    'table': 'Table',
                    'insert-table': 'Insert Table',
                    'insert-row-above': 'Insert Row Above',
                    'insert-row-below': 'Insert Row Below',
                    'insert-column-left': 'Insert Column Left',
                    'insert-column-right': 'Insert Column Right',
                    'delete-row': 'Delete Row',
                    'delete-column': 'Delete Column',
                    'delete-table': 'Delete Table',
                    'add-head': 'Add Head',
                    'delete-head': 'Delete Head',
                    'rows': 'Rows',
                    'columns': 'Columns',
                },
            },

            getTemplate: function () {
                return (
                    String() +
                    '<div class="modal-section" id="redactor-modal-table-insert">' +
                    '<section>' +
                    '<label>' + this.lang.get('rows') + '</label>' +
                    '<input type="number" id="redactor-table-rows" value="3" min="1" max="20" style="width: 100%; padding: 8px; margin-bottom: 10px;" />' +
                    '</section>' +
                    '<section>' +
                    '<label>' + this.lang.get('columns') + '</label>' +
                    '<input type="number" id="redactor-table-columns" value="3" min="1" max="10" style="width: 100%; padding: 8px; margin-bottom: 10px;" />' +
                    '</section>' +
                    '<section>' +
                    '<button id="redactor-modal-button-action">Insert</button>' +
                    '<button id="redactor-modal-button-cancel">Cancel</button>' +
                    '</section>' +
                    '</div>'
                );
            },

            init: function () {
                var dropdown = {};

                dropdown.insert_table = {
                    title: this.lang.get('insert-table'),
                    func: this.table.showModal,
                };
                dropdown.insert_row_above = {
                    title: this.lang.get('insert-row-above'),
                    func: this.table.addRowAbove,
                };
                dropdown.insert_row_below = {
                    title: this.lang.get('insert-row-below'),
                    func: this.table.addRowBelow,
                };
                dropdown.insert_column_left = {
                    title: this.lang.get('insert-column-left'),
                    func: this.table.addColumnLeft,
                };
                dropdown.insert_column_right = {
                    title: this.lang.get('insert-column-right'),
                    func: this.table.addColumnRight,
                };
                dropdown.add_head = {
                    title: this.lang.get('add-head'),
                    func: this.table.addHead,
                };
                dropdown.delete_head = {
                    title: this.lang.get('delete-head'),
                    func: this.table.deleteHead,
                };
                dropdown.delete_row = {
                    title: this.lang.get('delete-row'),
                    func: this.table.deleteRow,
                };
                dropdown.delete_column = {
                    title: this.lang.get('delete-column'),
                    func: this.table.deleteColumn,
                };
                dropdown.delete_table = {
                    title: this.lang.get('delete-table'),
                    func: this.table.deleteTable,
                };

                var button = this.button.addAfter('link', 'table', this.lang.get('table'));
                this.button.setIcon(button, '<i class="fal fa-table"></i>');
                this.button.addDropdown(button, dropdown);
            },

            showModal: function () {
                this.modal.addTemplate('table', this.table.getTemplate());
                this.modal.load('table', this.lang.get('insert-table'), 400);
                this.modal.getActionButton().text(this.lang.get('insert')).on('click', this.table.insert);
                this.selection.save();
                this.modal.show();
            },

            insert: function () {
                var rows = parseInt($('#redactor-table-rows').val(), 10) || 3;
                var columns = parseInt($('#redactor-table-columns').val(), 10) || 3;

                this.modal.close();
                this.selection.restore();
                this.buffer.set();

                var tableHtml = '<table style="border-collapse: collapse; width: 100%;">';
                for (var i = 0; i < rows; i++) {
                    tableHtml += '<tr>';
                    for (var j = 0; j < columns; j++) {
                        tableHtml += '<td style="border: 1px solid #ccc; padding: 8px; min-width: 40px;">&nbsp;</td>';
                    }
                    tableHtml += '</tr>';
                }
                tableHtml += '</table><p></p>';

                this.insert.raw(tableHtml);
                this.code.sync();
            },

            // Helper: get current table cell
            getActiveCell: function () {
                var current = this.selection.current();
                return $(current).closest('td, th', this.core.editor()[0]);
            },

            getActiveTable: function () {
                var $cell = this.table.getActiveCell();
                return $cell.closest('table', this.core.editor()[0]);
            },

            addRowAbove: function () {
                var $cell = this.table.getActiveCell();
                if ($cell.length === 0) return;

                this.buffer.set();
                var $row = $cell.closest('tr');
                var numCols = $row.children('td, th').length;
                var newRow = '<tr>';
                for (var i = 0; i < numCols; i++) {
                    newRow += '<td style="border: 1px solid #ccc; padding: 8px;">&nbsp;</td>';
                }
                newRow += '</tr>';
                $row.before(newRow);
                this.code.sync();
            },

            addRowBelow: function () {
                var $cell = this.table.getActiveCell();
                if ($cell.length === 0) return;

                this.buffer.set();
                var $row = $cell.closest('tr');
                var numCols = $row.children('td, th').length;
                var newRow = '<tr>';
                for (var i = 0; i < numCols; i++) {
                    newRow += '<td style="border: 1px solid #ccc; padding: 8px;">&nbsp;</td>';
                }
                newRow += '</tr>';
                $row.after(newRow);
                this.code.sync();
            },

            addColumnLeft: function () {
                var $cell = this.table.getActiveCell();
                if ($cell.length === 0) return;

                this.buffer.set();
                var index = $cell.index();
                var $table = this.table.getActiveTable();
                $table.find('tr').each(function () {
                    var $cells = $(this).children('td, th');
                    var tag = $cells.eq(index).prop('tagName').toLowerCase();
                    $cells.eq(index).before('<' + tag + ' style="border: 1px solid #ccc; padding: 8px;">&nbsp;</' + tag + '>');
                });
                this.code.sync();
            },

            addColumnRight: function () {
                var $cell = this.table.getActiveCell();
                if ($cell.length === 0) return;

                this.buffer.set();
                var index = $cell.index();
                var $table = this.table.getActiveTable();
                $table.find('tr').each(function () {
                    var $cells = $(this).children('td, th');
                    var tag = $cells.eq(index).prop('tagName').toLowerCase();
                    $cells.eq(index).after('<' + tag + ' style="border: 1px solid #ccc; padding: 8px;">&nbsp;</' + tag + '>');
                });
                this.code.sync();
            },

            addHead: function () {
                var $table = this.table.getActiveTable();
                if ($table.length === 0) return;
                if ($table.find('thead').length > 0) return;

                this.buffer.set();
                var numCols = $table.find('tr:first').children('td, th').length;
                var headHtml = '<thead><tr>';
                for (var i = 0; i < numCols; i++) {
                    headHtml += '<th style="border: 1px solid #ccc; padding: 8px; font-weight: bold;">&nbsp;</th>';
                }
                headHtml += '</tr></thead>';
                $table.prepend(headHtml);
                this.code.sync();
            },

            deleteHead: function () {
                var $table = this.table.getActiveTable();
                if ($table.length === 0) return;

                this.buffer.set();
                $table.find('thead').remove();
                this.code.sync();
            },

            deleteRow: function () {
                var $cell = this.table.getActiveCell();
                if ($cell.length === 0) return;

                this.buffer.set();
                var $row = $cell.closest('tr');
                var $table = $row.closest('table');
                $row.remove();

                if ($table.find('tr').length === 0) {
                    $table.remove();
                }
                this.code.sync();
            },

            deleteColumn: function () {
                var $cell = this.table.getActiveCell();
                if ($cell.length === 0) return;

                this.buffer.set();
                var index = $cell.index();
                var $table = this.table.getActiveTable();
                $table.find('tr').each(function () {
                    $(this).children('td, th').eq(index).remove();
                });

                if ($table.find('td, th').length === 0) {
                    $table.remove();
                }
                this.code.sync();
            },

            deleteTable: function () {
                var $table = this.table.getActiveTable();
                if ($table.length === 0) return;

                this.buffer.set();
                $table.remove();
                this.code.sync();
            },
        };
    };
})(jQuery);
